<template>
    <div>
        <div>
            <a href="javascript:void(0)" @click="show">
                <i class="far fa-envelope me-2 text-center" style="width: 1em;"></i>{{ contactName }}
            </a>
        </div>

        <!-- Modal -->
        <div class="modal fade" id="contact-modal" tabindex="-1" aria-labelledby="contact-modal" aria-hidden="true">
            <div class="modal-dialog">
                <div class="modal-content ">
                    <div class="modal-header">
                        <h5 class="modal-title" id="contact-modal-title">Contact {{ contactName }}</h5>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div class="modal-body">
                        <form action="javascript:void(0)" method="post" ref="contactForm">
                            <input type="hidden" name="event" :value="eventId" />
                            
                            <input class="form-control" type="text" name="name" id="in-name" placeholder="Your Name" required v-model="senderName" />
                            <label class="form-label" for="in-name">Your Name</label>

                            <input class="form-control" type="email" name="email" id="in-email" placeholder="your.email@company.org" required v-model="senderEmail" />
                            <label class="form-label" for="in-email">Email Address</label>

                            <input class="form-control" type="text" name="subject" id="in-subject" placeholder="Subject" required v-model="subject" />
                            <label class="form-label" for="in-subject">Subject</label>

                            <textarea class="form-control" name="message" id="in-body" placeholder="Message..." required v-model="message"></textarea>
                            <label class="form-label" for="in-body">Message</label>
                        </form>
                        <div v-if="cfTurnstileSiteKey">
                            <cloudflare-turnstile :cf-turnstile-site-key="cfTurnstileSiteKey" @verify="verify"></cloudflare-turnstile>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                        <button type="button" class="btn btn-primary" @click="submit" :disabled="!submitable"><i class="far fa-paper-plane me-2"></i>Send</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
import CloudflareTurnstile from './Turnstile.vue';

export default {
    data() {
        return {
            senderName: '',
            senderEmail: '',
            subject: '',
            message: '',
            cf_turnstile_token: '',
        };
    },

    components: { CloudflareTurnstile },

    props: {
        contactName: {
            type: String,
            default: 'Unknown'
        },
        eventId: {
            type: String,
            required: true,
            default: ''
        },
        cfTurnstileSiteKey: {
            type: String,
            required: true,
            default: '',
        },
    },

    computed: {
        submitable() {
            return this.senderName.length && this.senderEmail.length && this.subject.length && (this.message.length > 5);
        }
    },

    methods: {
        show() {
            this.modal.show();
        },

        verify(token) {
            this.cf_turnstile_token = token;
        },

        submit() {
            const data = {
                cf_turnstile_token: this.cf_turnstile_token,
                event: this.eventId,
                senderName: this.senderName,
                senderEmail: this.senderEmail,
                subject: this.subject,
                message: this.message,
            };

            let valid = true;
            for (const [k, v] of Object.entries(this.$refs.contactForm)) {
                v.classList.remove('is-invalid');
                if (v.value == '') {
                    v.classList.add('is-invalid');
                    valid = false;
                }
            }
            
            if (!valid) {
                console.warn('Invalid entry');
                let data = {
                    'body': 'Missing or invalid information.',
                    'heading': '<i class="fas fa-exclamation-triangle text-warning me-2"></i>Invalid Entry',
                };
                this.eventHub.$emit('toast_add', data);

                return;
            }

            axios.post('/api/contact', data)
            .then( response => {
                this.modal._element.addEventListener('hidden.bs.modal', event => {
                    this.$refs.contactForm.reset();

                    let data = {
                        'heading': '<i class="fas fa-check-circle text-success me-2"></i>Message Sent',
                        'body': 'Your message has been sent successfully.'
                    };
                    this.eventHub.$emit('toast_add', data);

                }, { once: true });

                this.modal.hide();
            })
            .catch( error => {
                console.log(error);

                let data = {
                    'heading': '<i class="fas fa-exclamation-triangle text-danger me-2"></i>Message Failed',
                    'body': 'Your message failed to send.'
                }
                this.eventHub.$emit('toast_add', data);
            });
        },

    },

    mounted() {
        this.modal = new bootstrap.Modal('#contact-modal');
    },
};
</script>